import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=3452b750&scoped=true&"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts&"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=3452b750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452b750",
  null
  
)

export default component.exports